<template>
    <div class="login_content" :style="{backgroundImage: 'url(' + bgimg + ')'}">
        <div class="login_box">
            <div class="login_clear">
                <div class="register_logo"><img :src="logoimg" alt="logo" /></div>
                <div class="register_content">
                    <div class="register_title">
                        <template v-if="state == 0">
                            <h2>注册成功</h2>
                            <p>注册信息已提交成功审核成功后即可登录订货平台</p>
                        </template>
                        <template v-if="state == 2">
                            <h2>审核失败</h2>
                            <p>提交的信息审核失败了请与客服联系</p>
                        </template>
                    </div>
                </div>
                <div class="result_content clear">
                    <div class="result_left">
                        <img v-if="state == 0" src="static/images/result_examine.png" />
                        <img v-else src="static/images/result_error.png" />
                    </div>
                    <div class="result_right">
                        <div class="result_list_content">
                            <div class="result_list_box" v-if="state == 0">
                                <span>账号状态：</span>
                                <small class="orange">{{statetxt}}</small>
                            </div>
                            <div class="result_list_box" v-if="state == 2">
                                <span>失败原因：</span>
                                <small>{{failtxt}}</small>
                            </div>
                            <div class="result_list_box">
                                <span>公司名称：</span>
                                <small>{{companyname}}</small>
                            </div>
                            <div class="result_list_box">
                                <span>登录账号：</span>
                                <small>{{login}}</small>
                            </div>
                        </div>
                        <Button class="gobacklogin_btn" type="warning" @click="goback" long>返回登录</Button>
                    </div>
                </div>
                <div class="login_copyright_content"><span>{{tcpip}}</span></div>
            </div>
        </div>
        <!-- 漂浮客服 -->
        <ServerFixed></ServerFixed>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import qs from 'Qs'
import ServerFixed from '@/components/component/serverfixed.vue'

export default {
    components: {ServerFixed},
    data() {
        return {
            logoimg: '', // logo
            bgimg: '', // 背景图
            tcpip: '', // 备案信息
            state: 0, // 审核状态  0 待审核 1 审核通过 2 审核失败
            statetxt: '待审核', // 帐号状态
            failtxt: '信息填写有误，联系不到对应的负责人，请与我们联系核实信息', // 失败原因
            companyname: '河南省娃哈哈有限公司', // 公司名称
            login: '15903740607', // 登录帐号
        }
    },
    methods: {
        getBaseInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.logininfo + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    this.logoimg = response.data.msg.baseinfo.orderinglogo
                    this.bgimg = response.data.msg.backgroundlist[0]
                    this.tcpip = response.data.msg.tcpip
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getInfo () { // 获取数据
            let data = {
                uid: this.$route.params.uid
            }
            axios({
                url: this.getWebsite() + api.result + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    if (response.data.msg.customerone.pass_status == 1) {
                        localStorage.setItem("Flag", "requireAuth")
                        this.$router.push('/')
                    } else {
                        this.state = response.data.msg.customerone.pass_status
                        this.companyname = response.data.msg.customerone.name
                        this.login = response.data.msg.customerone.account
                        this.failtxt = response.data.msg.customerone.nopassreason
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        goback () {
            if (this.state != 1) localStorage.removeItem("Flag")
            this.$router.push('/login')
        }
    },
    created () {
        this.getBaseInfo()
        this.getInfo()
    }
}
</script>

<style scoped>

.login_box {
    height: 580px;
    margin: -290px 0 0 -450px;
}

.result_content {
    padding: 25px 90px 0;
}

.result_left {
    width: 300px;
    height: 300px;
    float: left;
    overflow: hidden;
}

.result_left img {
    width: 100%;
    min-height: 100%;
}

.result_right {
    width: 360px;
    padding-top: 30px;
    float: right;
}

.result_list_box {
    min-height: 60px;
    display: flex;
    flex-direction: row;
    padding-bottom: 20px;
}

.result_list_box span {
    width: 80px;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 16px;
    color: #666;
    display: inline-block;
    vertical-align: top;
}

.result_list_box small {
    width: 280px;
    font-size: 16px;
    color: #143ca9;
    word-break: break-all;
    display: inline-block;
}

.result_list_box small.orange {
    color: #FF8000;
}

.gobacklogin_btn {
    height: 48px;
    line-height: 38px;
    font-size: 16px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/login/result.vue